var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "preview_wrap"
    },
    [
      _c("div", { staticClass: "preview_midle" }, [
        _c("div", { staticClass: "header" }, [
          _vm.stuName
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.stuName) +
                    "《" +
                    _vm._s(_vm.name) +
                    "（" +
                    _vm._s(_vm.total) +
                    "）》作答详情"
                )
              ])
            : _c("p", [
                _vm._v(_vm._s(_vm.name) + "（" + _vm._s(_vm.total) + "）")
              ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tabs" },
          [
            _c("span", { staticClass: "fraction" }, [
              _c("span", { staticStyle: { "font-size": "32px" } }, [
                _vm._v(_vm._s(_vm.fraction))
              ]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: require("../../../../../../static/images/study/icon/underline.png")
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              _vm._l(_vm.questionTabNames, function(item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: {
                    label: item.sectionAlias || item.sectionName,
                    name: "page" + index
                  }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "contents",
            staticClass: "section",
            style: { height: _vm.styleHeight },
            on: { scroll: _vm.handleScroll }
          },
          [
            _c("div", { staticClass: "test" }, [
              _c(
                "ul",
                _vm._l(_vm.questionContent, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "test-item",
                      attrs: { id: ["page" + index] }
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.chnNumCharStr(index)) +
                            " 、" +
                            _vm._s(item.sectionAlias || item.sectionName) +
                            "\n                "
                        ),
                        _c("span", [
                          _vm._v("（" + _vm._s(item.sectionPrompt) + "）")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(item.questions, function(v, i) {
                          return _c(
                            "li",
                            { key: i, staticClass: "test_small" },
                            [
                              v.internalTypeId !== 6
                                ? _c("div", [
                                    _c("div", { staticClass: "text_box" }, [
                                      v.internalTypeId === 9
                                        ? _c(
                                            "span",
                                            { staticClass: "text_index1" },
                                            [
                                              _vm._v(
                                                _vm._s(v.questionNum) + "."
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.internalTypeId !== 9
                                        ? _c(
                                            "span",
                                            { staticClass: "text_index" },
                                            [
                                              _vm._v(
                                                _vm._s(v.questionNum) + "."
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.internalTypeId === 9
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "test_small_title1"
                                            },
                                            [
                                              _c("p", {
                                                staticClass: "text",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    v.questionContent
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.internalTypeId !== 9
                                        ? _c("div", {
                                            staticClass: "test_small_title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                v.questionContent
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.internalTypeId === 1 ||
                                      v.internalTypeId === 2
                                        ? _c("div", {
                                            staticClass: "answer_option"
                                          })
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    v.internalTypeId === 1
                                      ? _c("ul", { staticClass: "answer" }, [
                                          _c(
                                            "div",
                                            { staticClass: "answer_radio" },
                                            [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  model: {
                                                    value: v.answer,
                                                    callback: function($$v) {
                                                      _vm.$set(v, "answer", $$v)
                                                    },
                                                    expression: "v.answer"
                                                  }
                                                },
                                                _vm._l(v.items, function(k, j) {
                                                  return _c(
                                                    "li",
                                                    { key: j },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: {
                                                            label: k.itemKey,
                                                            disabled:
                                                              v.answer ==
                                                              k.itemKey
                                                                ? false
                                                                : true
                                                          }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                k.itemKey
                                                              ) + "："
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "radio_item",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                k.itemValue
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }),
                                                0
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("img", {
                                            attrs: {
                                              src: _vm.handleJudge(v.isRight)
                                            }
                                          })
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.internalTypeId === 2
                                      ? _c("ul", { staticClass: "answer" }, [
                                          _c(
                                            "div",
                                            { staticClass: "answer_radio" },
                                            [
                                              _c(
                                                "el-checkbox-group",
                                                {
                                                  model: {
                                                    value:
                                                      v.answer == undefined
                                                        ? ""
                                                        : v.answer.split(","),
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        v.answer == undefined
                                                          ? ""
                                                          : v.answer,
                                                        "split(',')",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "v.answer==undefined?'' : v.answer.split(',')"
                                                  }
                                                },
                                                _vm._l(v.items, function(k, j) {
                                                  return _c(
                                                    "li",
                                                    { key: j },
                                                    [
                                                      v.answer
                                                        ? _c(
                                                            "el-checkbox",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  v.answer !=
                                                                  "--"
                                                                    ? v.answer.includes(
                                                                        k.itemKey
                                                                      )
                                                                      ? false
                                                                      : true
                                                                    : true,
                                                                label: k.itemKey
                                                              }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    k.itemKey
                                                                  ) + "："
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("p", {
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    k.itemValue
                                                                  )
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        : _c(
                                                            "el-checkbox",
                                                            {
                                                              attrs: {
                                                                disabled: "",
                                                                label: k.itemKey
                                                              }
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    k.itemKey
                                                                  ) + "："
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("p", {
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    k.itemValue
                                                                  )
                                                                }
                                                              })
                                                            ]
                                                          )
                                                    ],
                                                    1
                                                  )
                                                }),
                                                0
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("img", {
                                            attrs: {
                                              src: _vm.handleJudge(v.isRight)
                                            }
                                          })
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.internalTypeId === 3
                                      ? _c("ul", { staticClass: "answer" }, [
                                          _c(
                                            "div",
                                            { staticClass: "answer_radio" },
                                            [
                                              _c(
                                                "li",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: {
                                                        label: "正确",
                                                        disabled:
                                                          (v.answer == "错误"
                                                            ? true
                                                            : false) ||
                                                          (v.answer ==
                                                            undefined || "--"
                                                            ? true
                                                            : false)
                                                      },
                                                      model: {
                                                        value: v.answer,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            v,
                                                            "answer",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "v.answer"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.answerExchange(
                                                            v.englishOption,
                                                            "正确"
                                                          )
                                                        ) +
                                                          "\n                          "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      attrs: {
                                                        label: "错误",
                                                        disabled:
                                                          (v.answer == "正确"
                                                            ? true
                                                            : false) ||
                                                          (v.answer ==
                                                            undefined || "--"
                                                            ? true
                                                            : false)
                                                      },
                                                      model: {
                                                        value: v.answer,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            v,
                                                            "answer",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "v.answer"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.answerExchange(
                                                            v.englishOption,
                                                            "错误"
                                                          )
                                                        ) +
                                                          "\n                          "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("img", {
                                            attrs: {
                                              src: _vm.handleJudge(v.isRight)
                                            }
                                          })
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.internalTypeId === 9
                                      ? _c("div", { staticClass: "answer" }, [
                                          _c(
                                            "div",
                                            { staticClass: "scoreBoxClass" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "得分： " +
                                                    _vm._s(
                                                      Number(
                                                        v.userScore
                                                      ).toFixed(2)
                                                    )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "标准总分： " +
                                                    _vm._s(
                                                      Number(v.score).toFixed(2)
                                                    )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          v.flag && _vm.analysisFlag
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "answerShow",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.checkDetails(v)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        查看评分详情\n                      "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "answerIf" }, [
                                      (v.internalTypeId === 1 ||
                                        v.internalTypeId === 2 ||
                                        v.internalTypeId === 3) &&
                                      _vm.analysisFlag
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                        正确答案：\n                        "
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.answerExchange(
                                                    v.englishOption,
                                                    v.questionAnswer
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.internalTypeId === 1 ||
                                      v.internalTypeId === 2 ||
                                      v.internalTypeId === 3
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                        我的答案：\n                        "
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  v.answer == "remark" ||
                                                    v.answer == ""
                                                    ? "--"
                                                    : _vm.answerExchange(
                                                        v.englishOption,
                                                        v.answer
                                                      )
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    v.internalTypeId === 4 && _vm.analysisFlag
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                      正确答案：\n                      "
                                          ),
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                v.questionAnswer
                                              )
                                            }
                                          })
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.flag &&
                                    v.internalTypeId !== 9 &&
                                    _vm.analysisFlag
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "analysis",
                                            on: {
                                              click: function($event) {
                                                return _vm.openAnalysis(v)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      打开解析\n                      "
                                            ),
                                            _c("img", {
                                              attrs: { src: _vm.imgSrcDown }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !v.flag &&
                                    v.internalTypeId !== 9 &&
                                    _vm.analysisFlag
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "analysis",
                                            on: {
                                              click: function($event) {
                                                return _vm.openAnalysis(v)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      收起解析\n                      "
                                            ),
                                            _c("img", {
                                              attrs: { src: _vm.imgSrcUp }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !v.flag &&
                                    v.internalTypeId !== 9 &&
                                    _vm.analysisFlag
                                      ? _c("span", {
                                          staticClass: "analysis_cont",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              v.questionAnalysis
                                                ? v.questionAnalysis
                                                : "暂无解析"
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !v.flag && v.internalTypeId == 9
                                      ? _c(
                                          "div",
                                          { staticClass: "commentCont" },
                                          [
                                            _c("div", {
                                              staticClass: "comment1"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "comment2" },
                                              [
                                                _c("my-component", {
                                                  attrs: {
                                                    isShow: "",
                                                    optObject: _vm.optObject,
                                                    refresh: _vm.refresh,
                                                    myId: v.questionId,
                                                    type: _vm.type,
                                                    preview: true,
                                                    companyCode: _vm.companyCode
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "comment3"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              v.internalTypeId === 6 &&
                              item.questions.length > 1
                                ? _c("div", { staticClass: "line" })
                                : _vm._e(),
                              _vm._v(" "),
                              v.internalTypeId === 6
                                ? _c(
                                    "div",
                                    { staticClass: "combination" },
                                    [
                                      v.internalTypeId === 9
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "test_small_title1"
                                            },
                                            [
                                              _c("p", {
                                                staticClass: "text",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    v.questionContent
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.questionNum ==
                                      v.questionNum +
                                        v.childQuestions.length -
                                        1
                                        ? _c(
                                            "p",
                                            { staticClass: "question_index" },
                                            [
                                              _vm._v(
                                                "阅读以下内容，回答第" +
                                                  _vm._s(v.questionNum) +
                                                  "题"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            { staticClass: "question_index" },
                                            [
                                              _vm._v(
                                                "阅读以下内容，回答第" +
                                                  _vm._s(v.questionNum) +
                                                  "-" +
                                                  _vm._s(
                                                    v.questionNum +
                                                      v.childQuestions.length -
                                                      1
                                                  ) +
                                                  "题"
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      v.internalTypeId !== 9
                                        ? _c("div", {
                                            staticClass: "test_small_title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                v.questionContent
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(v.childQuestions, function(
                                        single,
                                        m
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: m,
                                            staticClass: "groupQuestion"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "question_content"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(single.questionNum) +
                                                      "."
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("p", {
                                                  staticClass: "text",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      single.questionContent
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                single.internalTypeId === 1 ||
                                                single.internalTypeId === 2
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "answer_option"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          （\n                          "
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              single.answer ==
                                                                "remark" || ""
                                                                ? "--"
                                                                : single.answer
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          "）\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            single.internalTypeId === 1
                                              ? _c(
                                                  "ul",
                                                  { staticClass: "answer" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "answer_radio"
                                                      },
                                                      [
                                                        _c(
                                                          "el-radio-group",
                                                          {
                                                            model: {
                                                              value:
                                                                single.answer,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  single,
                                                                  "answer",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "single.answer"
                                                            }
                                                          },
                                                          _vm._l(
                                                            single.items,
                                                            function(k, j) {
                                                              return _c(
                                                                "li",
                                                                { key: j },
                                                                [
                                                                  _c(
                                                                    "el-radio",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          k.itemKey,
                                                                        disabled:
                                                                          single.answer ==
                                                                          k.itemKey
                                                                            ? false
                                                                            : true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              k.itemKey
                                                                            ) +
                                                                              "："
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "radio_item",
                                                                          domProps: {
                                                                            innerHTML: _vm._s(
                                                                              k.itemValue
                                                                            )
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.handleJudge(
                                                          single.isRight
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.internalTypeId === 2
                                              ? _c(
                                                  "ul",
                                                  { staticClass: "answer" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "answer_radio"
                                                      },
                                                      [
                                                        _c(
                                                          "el-checkbox-group",
                                                          {
                                                            model: {
                                                              value:
                                                                single.answer ==
                                                                undefined
                                                                  ? ""
                                                                  : single.answer.split(
                                                                      ","
                                                                    ),
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  single.answer ==
                                                                    undefined
                                                                    ? ""
                                                                    : single.answer,
                                                                  "split(',')",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "single.answer==undefined?'' : single.answer.split(',')"
                                                            }
                                                          },
                                                          _vm._l(
                                                            single.items,
                                                            function(k, j) {
                                                              return _c(
                                                                "li",
                                                                { key: j },
                                                                [
                                                                  single.answer
                                                                    ? _c(
                                                                        "el-checkbox",
                                                                        {
                                                                          attrs: {
                                                                            disabled:
                                                                              single.answer !=
                                                                              "--"
                                                                                ? single.answer.includes(
                                                                                    k.itemKey
                                                                                  )
                                                                                  ? false
                                                                                  : true
                                                                                : true,
                                                                            label:
                                                                              k.itemKey
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  k.itemKey
                                                                                ) +
                                                                                  "："
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              domProps: {
                                                                                innerHTML: _vm._s(
                                                                                  k.itemValue
                                                                                )
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "el-checkbox",
                                                                        {
                                                                          attrs: {
                                                                            disabled:
                                                                              "",
                                                                            label:
                                                                              k.itemKey
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  k.itemKey
                                                                                ) +
                                                                                  "："
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              domProps: {
                                                                                innerHTML: _vm._s(
                                                                                  k.itemValue
                                                                                )
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.handleJudge(
                                                          single.isRight
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.internalTypeId === 3
                                              ? _c(
                                                  "ul",
                                                  { staticClass: "answer" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "answer_radio"
                                                      },
                                                      [
                                                        _c(
                                                          "li",
                                                          [
                                                            _c(
                                                              "el-radio",
                                                              {
                                                                attrs: {
                                                                  label: "正确",
                                                                  disabled:
                                                                    (single.answer ==
                                                                    "错误"
                                                                      ? true
                                                                      : false) ||
                                                                    (single.answer ==
                                                                      undefined ||
                                                                    "--"
                                                                      ? true
                                                                      : false)
                                                                },
                                                                model: {
                                                                  value:
                                                                    single.answer,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      single,
                                                                      "answer",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "single.answer"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.answerExchange(
                                                                      single.englishOption,
                                                                      "正确"
                                                                    )
                                                                  ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "li",
                                                          [
                                                            _c(
                                                              "el-radio",
                                                              {
                                                                attrs: {
                                                                  label: "错误",
                                                                  disabled:
                                                                    (single.answer ==
                                                                    "正确"
                                                                      ? true
                                                                      : false) ||
                                                                    (single.answer ==
                                                                      undefined ||
                                                                    "--"
                                                                      ? true
                                                                      : false)
                                                                },
                                                                model: {
                                                                  value:
                                                                    single.answer,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      single,
                                                                      "answer",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "single.answer"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.answerExchange(
                                                                      single.englishOption,
                                                                      "错误"
                                                                    )
                                                                  ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.handleJudge(
                                                          single.isRight
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.internalTypeId === 9
                                              ? _c(
                                                  "div",
                                                  { staticClass: "answer" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "scoreBoxClass"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "得分： " +
                                                              _vm._s(
                                                                Number(
                                                                  single.userScore
                                                                ).toFixed(2)
                                                              )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            "标准总分： " +
                                                              _vm._s(
                                                                Number(
                                                                  single.score
                                                                ).toFixed(2)
                                                              )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    single.flag &&
                                                    single.internalTypeId ===
                                                      9 &&
                                                    _vm.analysisFlag
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "answerShow",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.checkDetails(
                                                                  single
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          查看评分详情\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "answerIf" },
                                              [
                                                (single.internalTypeId === 1 ||
                                                  single.internalTypeId === 2 ||
                                                  single.internalTypeId ===
                                                    3) &&
                                                _vm.analysisFlag
                                                  ? _c("p", [
                                                      _vm._v(
                                                        "\n                          正确答案：\n                          "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.answerExchange(
                                                              single.englishOption,
                                                              single.questionAnswer
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                single.internalTypeId === 1 ||
                                                single.internalTypeId === 2 ||
                                                single.internalTypeId === 3
                                                  ? _c("p", [
                                                      _vm._v(
                                                        "\n                          我的答案：\n                          "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            v.answer ==
                                                              "remark" ||
                                                              single.answer ==
                                                                ""
                                                              ? "--"
                                                              : _vm.answerExchange(
                                                                  single.englishOption,
                                                                  single.answer
                                                                )
                                                          )
                                                        )
                                                      ])
                                                    ])
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            single.internalTypeId === 4 &&
                                            _vm.analysisFlag
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                        正确答案：\n                        "
                                                  ),
                                                  _c("p", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        single.questionAnswer
                                                      )
                                                    }
                                                  })
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.flag &&
                                            single.internalTypeId !== 9 &&
                                            _vm.analysisFlag
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "analysis",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          single
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        打开解析\n                        "
                                                    ),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcDown
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !single.flag &&
                                            single.internalTypeId !== 9 &&
                                            _vm.analysisFlag
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "analysis",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          single
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        收起解析\n                        "
                                                    ),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcUp
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !single.flag &&
                                            single.internalTypeId !== 9 &&
                                            _vm.analysisFlag
                                              ? _c("span", {
                                                  staticClass: "analysis_cont",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      single.questionAnalysis
                                                        ? single.questionAnalysis
                                                        : "暂无解析"
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !single.flag &&
                                            single.internalTypeId == 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "commentCont"
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "comment1"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "comment2"
                                                      },
                                                      [
                                                        _c("my-component", {
                                                          attrs: {
                                                            isShow: "",
                                                            optObject:
                                                              _vm.optObject,
                                                            refresh:
                                                              _vm.refresh,
                                                            myId:
                                                              single.questionId,
                                                            type: _vm.type,
                                                            preview: true,
                                                            companyCode:
                                                              _vm.companyCode
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass: "comment3"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              v.internalTypeId === 6 &&
                              item.questions.length > 1
                                ? _c("div", { staticClass: "line" })
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e769608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e769608","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testing/stuPreview.vue
// module id = null
// module chunks = 